<template>
    <div class="navbar">
        <v-app-bar app color="white" max-height="70px" height="70px">
            <v-app-bar-nav-icon @click.stop="show_drawer = !show_drawer"
                                class="btn-drawer" />

            <v-spacer />

            <v-list>
                <v-list-item>
                    <v-tooltip bottom color="blue">
                        <template v-slot:activator="{ on, attrs }">
                            <router-link to="./config-2fa">
                                <v-btn v-bind="attrs"
                                       v-on="on"
                                       icon>
                                    <v-icon icon="mdi-cog">mdi-cog</v-icon>
                                </v-btn>
                            </router-link>
                        </template>
                        <span>Configurações de acesso</span>
                    </v-tooltip>
                </v-list-item>
                <v-list-item>
                    <v-tooltip bottom color="blue">
                        <template v-slot:activator="{ on, attrs }">
                            <router-link to="./enable-2fa">
                                <v-btn v-bind="attrs"
                                       v-on="on"
                                       icon>
                                    <v-icon icon="mdi-cellphone-lock">mdi-cellphone-lock</v-icon>
                                </v-btn>
                            </router-link>
                        </template>
                        <span>Habilitar</span>
                    </v-tooltip>
                </v-list-item>
                <v-list-item>
                    <v-tooltip bottom color="blue">
                        <template v-slot:activator="{ on, attrs }">
                            <router-link to="./disable-2fa">
                                <v-btn v-bind="attrs"
                                       v-on="on"
                                       icon>
                                    <v-icon icon="mdi-cellphone-off">mdi-cellphone-off</v-icon>
                                </v-btn>
                            </router-link>
                        </template>
                        <span>Desabilitar</span>
                    </v-tooltip>
                </v-list-item>
                <v-list-item>
                    <v-tooltip bottom color="blue">
                        <template v-slot:activator="{ on, attrs }">
                            <router-link to="./reset-2fa">
                                <v-btn v-bind="attrs"
                                       v-on="on"
                                       icon>
                                    <v-icon icon="mdi-backup-restore">mdi-backup-restore</v-icon>
                                </v-btn>
                            </router-link>
                        </template>
                        <span>Reinicializar</span>
                    </v-tooltip>
                </v-list-item>
                <v-list-item>
                    <v-tooltip bottom color="blue">
                        <template v-slot:activator="{ on, attrs }">
                            <router-link to="./recovery-2fa">
                                <v-btn v-bind="attrs"
                                       v-on="on"
                                       icon>
                                    <v-icon icon="mdi-file-account">mdi-file-account</v-icon>
                                </v-btn>
                            </router-link>
                        </template>
                        <span>Gerar chaves de recuperação</span>
                    </v-tooltip>
                </v-list-item>
                <v-list-item>
                    <v-tooltip bottom color="blue">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs"
                                   v-on="on"
                                   icon
                                   @click="goBack">
                                <v-icon icon="mdi-arrow-left-circle">mdi-arrow-left-circle</v-icon>
                            </v-btn>
                        </template>
                        <span>Voltar para o aplicativo</span>
                    </v-tooltip>
                </v-list-item>
            </v-list>

            <v-spacer />
        </v-app-bar>

        <v-navigation-drawer v-model="show_drawer"
                             class="nav-drawer"
                             fixed
                             temporary>
            <v-list nav dense>
                <v-list-item-group>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn icon
                                   @click="goToConfig">
                                <v-icon icon="mdi-cog">mdi-cog</v-icon>
                                <span class="action-label">Configurações</span>
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn icon
                                   @click="goToEnable">
                                <v-icon icon="mdi-cellphone-lock">mdi-cellphone-lock</v-icon>
                                <span class="action-label">Habilitar</span>
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn icon
                                   @click="goToDisable">
                                <v-icon icon="mdi-cellphone-off">mdi-cellphone-off</v-icon>
                                <span class="action-label">Desabilitar</span>
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn icon
                                   @click="goToReset">
                                <v-icon icon="mdi-backup-restore">mdi-backup-restore</v-icon>
                                <span class="action-label">Reinicializar</span>
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn icon
                                   @click="goToRecovery">
                                <v-icon icon="mdi-file-account">mdi-file-account</v-icon>
                                <span class="action-label">Chaves de recup.</span>
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title>
                            <v-btn icon
                                   @click="goBack">
                                <v-icon icon="mdi-arrow-left-circle">mdi-arrow-left-circle</v-icon>
                                <span class="action-label">Voltar</span>
                            </v-btn>
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<style lang="css">
</style>

<style lang="css" scoped>
.btn-drawer {
  display: none;
}
.nav-drawer {
  height: 100vh !important;
}
.v-list {
  display: flex;
  align-items: center;
  height: 100%;
}
.v-list .v-list-item {
  padding: 0 0.3rem;
}
.v-list .v-list-item a.router-link-active {
  position: relative;
}
.v-list .v-list-item a.router-link-active::after {
  content: " ";
  width: 45px;
  height: 4px;
  background: var(--principal-azul);
  position: absolute;
  bottom: -12px;
  left: 2px;
}
.v-list .v-list-item {
  filter: invert(35%) brightness(99%) contrast(91%);
}
.navbar {
    z-index: 15;
}
.v-app-bar {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05) !important;
}
.v-tooltip__content {
  border-radius: 30px !important;
  top: 60px !important;
  z-index: 20 !important;
}
.v-tooltip__content::after {
  content: " ";
  position: absolute;
  bottom: 100%; /* At the top of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent var(--principal-azul) transparent;
}
.v-list .v-list-item:hover {
  filter: invert(35%) sepia(45%) saturate(2082%) hue-rotate(180deg)
    brightness(99%) contrast(91%);
}
@media screen and (max-width: 370px) {
  .btn-drawer {
    display: flex;
  }
  .v-app-bar .v-list {
    display: none;
  }
  .v-list .v-list-item .v-btn {
    width: 100%;
    align-items: center;
    align-content: center;
    justify-content: left;
  }
  .btn-drawer .v-list {
    flex-direction: column;
  }
}
</style>

<script lang="js">
export default              {
    data ()                 {
        return              {
            show_drawer: false
        }
    },
    methods                 : {
        getUser             () {
            return this.$store.getters.$userLogged;
        },
        goToConfig          () {
            if (this.$route.name !== 'TwoFactorAuthentication') {
                this.$router.push('./config-2fa');
            }
        },
        goToEnable          () {
            if (this.$route.name !== 'Enable2FA') {
                this.$router.push('./enable-2fa');
            }
        },
        goToDisable         () {
            if (this.$route.name !== 'Disable2FA') {
                this.$router.push('./disable-2fa');
            }
        },
        goToReset           () {
            if (this.$route.name !== 'Reset2FA') {
                this.$router.push('./reset-2fa');
            }
        },
        goToRecovery        () {
            if (this.$route.name !== 'Recovery2FA') {
                this.$router.push('./recovery-2fa');
            }
        },
        goBack              () {
            sessionStorage.setItem('home/view', 'Entities');
            this.$router.push("/home");
        }
    }
}
</script>